import TerminosUsoCompleto from './TerminosUsoCompleto'
export default TerminosUsoCompleto